import { ListFormCd001TabPreLimpezaComponent } from './../views/form-cd001/list-form-cd001-tab-preLimpeza.component';
// import { ListFormCd001TabRepasseComponent } from './../views/form-cd001/list-form-cd001-tab-repasse.component';
import { ListFormCd001TabClassificacaoComponent } from './../views/form-cd001/list-form-cd001-tab-classificacao.component';
import { FormCd001LimpezaComponent } from './../views/form-cd001/form-cd001-preLimpeza/form-cd001-limpeza.component';
import { SharedModule } from './shared.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AngularmaterialModule } from './angular-material-module';
import { NgxMaskModule, IConfig } from 'ngx-mask';
export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;
import { CurrencyMaskConfig, CurrencyMaskModule, CURRENCY_MASK_CONFIG } from 'ng2-currency-mask';
import { ListFormCd001ClassificacaoComponent } from '../views/form-cd001/form-cd001-classificacao/list-form-cd001-classificacao.component';
import { FormCd001ClassificacaoFilterComponent } from '../views/form-cd001/form-cd001-classificacao/form-cd001-classificacao-filter.component';
// import { FormCd001RepasseComponent } from '../views/form-cd001/form-cd001-repasse/form-cd001-repasse.component';
// import { Cd001CardRepasseIComponent } from '../views/form-cd001/form-cd001-repasse/partialViews/cd001-card-repasse-I.component';
// import { FormCd001RepasseFilterComponent } from '../views/form-cd001/form-cd001-repasse/form-cd001-repasse-filter.component';
import { FormCd001LimpezaFilterComponent } from '../views/form-cd001/form-cd001-preLimpeza/form-cd001-limpeza-filter.component';
// import { ListFormCd001RepasseComponent } from '../views/form-cd001/form-cd001-repasse/list-form-cd001-repasse.component';
import { ListFormCd001LimpezaComponent } from '../views/form-cd001/form-cd001-preLimpeza/list-form-cd001-limpeza.component';
import { FormCd001ClassificacaoComponent } from '../views/form-cd001/form-cd001-classificacao/form-cd001-classificacao.component';
import { Cd001CardClassificacaoIComponent } from '../views/form-cd001/form-cd001-classificacao/partialViews/cd001-card-classificacao-I.component';
import { Cd001CardClassificacaoIIComponent } from '../views/form-cd001/form-cd001-classificacao/partialViews/cd001-card-classificacao-II.component';
import { Cd001CardClassificacaoIIIComponent } from '../views/form-cd001/form-cd001-classificacao/partialViews/cd001-card-classificacao-III.component';
import { Cd001CardLimpezaIComponent } from '../views/form-cd001/form-cd001-preLimpeza/partialViews/cd001-card-limpeza-I.component';
import { Cd001CardLimpezaIIComponent } from '../views/form-cd001/form-cd001-preLimpeza/partialViews/cd001-card-limpeza-II.component';
import { Cd001CardLimpezaIIIComponent } from '../views/form-cd001/form-cd001-preLimpeza/partialViews/cd001-card-limpeza-III.component';
import { Cd001CardLimpezaIVComponent } from '../views/form-cd001/form-cd001-preLimpeza/partialViews/cd001-card-limpeza-IV.component';
import { Cd001CardLimpezaVComponent } from '../views/form-cd001/form-cd001-preLimpeza/partialViews/cd001-card-limpeza-V.component';
import { Cd001CardClassificacaoIVComponent } from '../views/form-cd001/form-cd001-classificacao/partialViews/cd001-card-classificacao-IV.component';
import { Cd001CardClassificacaoVComponent } from '../views/form-cd001/form-cd001-classificacao/partialViews/cd001-card-classificacao-V.component';
import { Cd001CardClassificacaoVIComponent } from '../views/form-cd001/form-cd001-classificacao/partialViews/cd001-card-classificacao-VI.component';
import { FormCd001PrelimpezaRoutingModule } from '../routes/form-cd001_prelimpeza.route';
import { FormCd001ClassificacaoRoutingModule } from '../routes/form-cd001_Classificacao.route';
import { Cd001CardClassificacaoBasicIVComponent } from '../views/form-cd001/form-cd001-classificacao/classificacao-basic/cd001-card-classificacao-basic-iv/cd001-card-classificacao-basic-iv.component';
import { Cd001CardGuideComponent } from '../views/form-cd001/form-cd001-preLimpeza/guideCard/cd001-card-guide.component';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'left',
    allowNegative: false,
    decimal: ',',
    precision: 2,
    prefix: '',
    suffix: '',
    thousands: '.'
};

@NgModule({
    declarations: [
        ListFormCd001TabPreLimpezaComponent,
        ListFormCd001TabClassificacaoComponent,
        ListFormCd001ClassificacaoComponent,
        ListFormCd001LimpezaComponent,
        FormCd001ClassificacaoFilterComponent,
        FormCd001LimpezaFilterComponent,
        FormCd001ClassificacaoComponent,
        Cd001CardClassificacaoIComponent,
        Cd001CardClassificacaoIIComponent,
        Cd001CardClassificacaoIIIComponent,
        Cd001CardClassificacaoIVComponent,
        Cd001CardClassificacaoVComponent,
        Cd001CardClassificacaoVIComponent,
        FormCd001LimpezaComponent,
        FormCd001ClassificacaoComponent,
        Cd001CardLimpezaIComponent,
        Cd001CardLimpezaIIComponent,
        Cd001CardLimpezaIIIComponent,
        Cd001CardLimpezaIVComponent,
        Cd001CardLimpezaVComponent,
        // Cd001CardClassificacaoBasicIVComponent,
        Cd001CardGuideComponent
    ],
    imports: [
        CommonModule,
        AngularmaterialModule,
        SharedModule,
        FormCd001PrelimpezaRoutingModule,
        FormCd001ClassificacaoRoutingModule,
        NgxMaskModule.forRoot(options),
        CurrencyMaskModule,
    ],
    providers: [
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig }
    ]
})

export class FormCd001Module {
}
